import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import './home.scss';
import {HomeComponent} from './home';
import {HomeIndexModule} from './home-index/home-index.module';
import {ArchidriveModule} from './archidrive/archidrive.module';
import {FatturazioneModule} from './fatturazione/fatturazione.module';
import {ConservazioneModule} from './conservazione/conservazione.module';
import {NotificheModule} from './notifiche/notifiche.module';
import {ViewStoricoConservazioneModule} from '../usersettings/view-storico-utilizzo/view-storico-utilizzo.module';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {
  $stateProvider
    .state('home', {
      url: '/home',
      views: {
        multiContent: {
          template: '<home flex="100"></home>'
        }
      },
      abstract: true
    });
};

stateConfig.$inject = ['$stateProvider'];

export const HomeModule: string = ng
  .module('home', [
    'ui.bootstrap',
    uiRouter,
    HomeIndexModule,
    ArchidriveModule,
    FatturazioneModule,
    ConservazioneModule,
    NotificheModule,
    ViewStoricoConservazioneModule,
  ])
  .component('home', HomeComponent)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/home.module.ts